import type { UpdateResolver } from '@urql/exchange-graphcache'
import type {
    DeleteTranscriptionBlockMutation,
    DeleteTranscriptionBlockMutationVariables,
    TranscriptionCreatedSubscription,
    TranscriptionCreatedSubscriptionVariables,
} from '@/generated/gql/graphql'
import { invalidateCache } from '../utils/invalidateCache'

const transcriptionsMutationsUpdaters: Record<string, UpdateResolver> = {
    deleteTranscriptionBlock: (
        _parent: DeleteTranscriptionBlockMutation,
        args: DeleteTranscriptionBlockMutationVariables,
        cache,
    ) => {
        cache.invalidate({
            __typename: 'Transcription',
            id: args.input.id,
        })
    },
}

const transcriptionsSubscriptionsUpdaters: Record<string, UpdateResolver> = {
    transcriptionBlocksCreatedV1: (
        _parent: TranscriptionCreatedSubscription,
        _args: TranscriptionCreatedSubscriptionVariables,
        cache,
    ) => {
        invalidateCache(cache, ['meetingV1', 'recordings'])
    },
}

export { transcriptionsMutationsUpdaters, transcriptionsSubscriptionsUpdaters }
